import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoaderComponent } from './components/loader/loader.component';
import { SupplierFilterPipe } from './pipes/supplier-filter.pipe';
import { IsDeletedExceptionPipe } from './pipes/active-exception.pipe';
import { SupplierProfileFilterPipe } from './pipes/supplier-profile-filter.pipe';
import { FormsModule } from '@angular/forms';
import { UserSubscriptionFilterPipe } from './pipes/user-subscription-filter.pipe';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    LoaderComponent,
    SupplierFilterPipe,
    IsDeletedExceptionPipe,
    SupplierProfileFilterPipe,
    UserSubscriptionFilterPipe,
  ],
  imports: [RouterModule, CommonModule, FormsModule],
  exports: [
    RouterModule,
    CommonModule,
    FormsModule,
    HeaderComponent,
    FooterComponent,
    LoaderComponent,
    SupplierFilterPipe,
    SupplierProfileFilterPipe,
    IsDeletedExceptionPipe,
    UserSubscriptionFilterPipe,
  ],
})
export class SharedModule {}
